const GRATUITO_ID = 1;
const BASICO_MENSAL_ID = 2;
const BASICO_ANUAL_ID = 5;
const PREMIUM_MENSAL_ID = 3;
const PREMIUM_ANUAL_ID = 6;
const ILIMITADO_ID = 7;

export const BASICO_MENSAL = {
  id: BASICO_MENSAL_ID,
  valor: "24,90",
};
export const BASICO_ANUAL = {
  id: BASICO_ANUAL_ID,
  valor: "279,90",
  valorSemDesconto: "299,90",
};
export const PREMIUM_MENSAL = {
  id: PREMIUM_MENSAL_ID,
  valor: "29,90",
};
export const PREMIUM_ANUAL = {
  id: PREMIUM_ANUAL_ID,
  valor: "339,90",
  valorSemDesconto: "359,90",
};
export const GRATUITO = {
  id: GRATUITO_ID,
  valor: "0,00",
};
export const ILIMITADO = {
  id: ILIMITADO_ID,
  valor: "0,00",
};
